//constants definition
const HOME = 0
const EGIFTS = 1
const HAMPERS = 2
const WITHDRAWFUNDS = 3
const GIFTS = 4

//contants voucher categories
const TECH_CAT = 8
const EXPERIENCES_CAT = 9
const HOME_CAT = 4
const FASHION_CAT = 1
const FOOD_CAT = 5
const HAMPERS_CAT = 3
const ANYCARD_CAT = -1
const UNSPLASHCLIENTID = "aGa7_M0WWNIGvMQhCLSTI-gA_3vO-2Emr2K3iCvqfA0";
const GIPHYCLIENTID = "9I6dSsevBQv5ruvT63gKFYV1yRj1YX04";
const FONTS = [
    { id: "font1", text: "Arial" },
    { id: "font2", text: "Arial Black" },
    { id: "font3", text: "Courier Prime" },
    { id: "font4", text: "Georgia" },
    { id: "font5", text: "Comic Sans MS" },
    { id: "font6", text: "Century Gothic" },
    { id: "font7", text: "Palatino Linotype" },
    { id: "font8", text: "Tahoma" },
    { id: "font9", text: "MS Serif" },
    { id: "font10", text: "Trebuchet MS" },
];

//Gift Price Values
const HIGHEST_PRICE = 'High'
const LOWEST_PRICE = 'Low'

const ORDER_SAVE_STATUS = 1
const DEFAULT_INDEX = 0
const DEFAULT_SELECTED_DETAILS ='Select Details'

export default {
    HOME: HOME,
    EGIFTS: EGIFTS,
    HAMPERS: HAMPERS,
    WITHDRAWFUNDS: WITHDRAWFUNDS,
    GIFTS: GIFTS,
    TECH_CAT: TECH_CAT,
    EXPERIENCES_CAT: EXPERIENCES_CAT,
    HOME_CAT: HOME_CAT,
    FASHION_CAT: FASHION_CAT,
    FOOD_CAT: FOOD_CAT,
    HAMPERS_CAT: HAMPERS_CAT,
    ANYCARD_CAT: ANYCARD_CAT,
    HIGHEST_PRICE: HIGHEST_PRICE,
    LOWEST_PRICE: LOWEST_PRICE,
    ORDER_SAVE_STATUS: ORDER_SAVE_STATUS,
    DEFAULT_SELECTED_DETAILS: DEFAULT_SELECTED_DETAILS,
    DEFAULT_INDEX: DEFAULT_INDEX,
    UNSPLASHCLIENTID: UNSPLASHCLIENTID,
    GIPHYCLIENTID: GIPHYCLIENTID,
    FONTS: FONTS,
}
